import React from 'react';
import { Portal } from './Portal';

const MenuItemModal = ({ children, isOpen, onClose }) => {
    if (!isOpen) {
        return null;
    }
    
    return (
        <Portal>
            <div className="modal fade show custom-modal-menu" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {children}
                    </div>
                </div>
            </div>
        </Portal>
    );
};

const Header = ({ children }) => (<div className="modal-header">{children}</div>);
const Body = ({ children }) => (<div className="modal-body">{children}</div>);
const Footer = ({ children }) => (<div className="modal-footer menu-item-modal__modal-footer__padding">{children}</div>);

MenuItemModal.Header = Header;
MenuItemModal.Body = Body;
MenuItemModal.Footer = Footer;

export { MenuItemModal };